import { useState } from 'react';
import apiService from '../services/api';

const useMedicamentsCrud = () => {
  const [isLoading, setIsLoading] = useState(false);

  const createMedicament = async (medicamentData) => {
    setIsLoading(true);
    try {
      const response = await apiService.createMedicament(medicamentData);
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la création du médicament:', error);
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const updateMedicament = async (id, medicamentData) => {
    setIsLoading(true);
    try {
      const response = await apiService.updateMedicament(id, medicamentData);
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la modification du médicament:', error);
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const deleteMedicament = async (id) => {
    setIsLoading(true);
    try {
      const response = await apiService.deleteMedicament(id);
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la suppression du médicament:', error);
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createMedicament,
    updateMedicament,
    deleteMedicament,
    isLoading
  };
};

export default useMedicamentsCrud;

